export default __webpack_public_path__ + "static/media/Mute_white.fef95342.svg";